import React from "react";
import Snowfall from "react-snowfall";

export default function NewYearSnow() {
  const [on, setOn] = React.useState(false);

  React.useEffect(() => {
    const now = new Date();
    const m = now.getMonth(); 
    const d = now.getDate();

    const isNewYearSeason = (m === 11 && d >= 20) || (m === 0 && d <= 5);
    const reduceMotion =
      window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches ?? false;

    setOn(isNewYearSeason && !reduceMotion);
  }, []);

  if (!on) return null;

  return (
    <Snowfall
      color="#fff"
      snowflakeCount={160}
      style={{
        position: "fixed",
        inset: 0,
        pointerEvents: "none",
        zIndex: 9999,
      }}
    />
  );
}
